import React, { useState, useEffect, useLayoutEffect } from 'react'
import Navbar from "../../components/Layouts/Navbar";
import ContentSection from '../../components/SamplePage/ContentSection';
import dynamic from 'next/dynamic'
const Footer = dynamic(() => import('../../components/Layouts/Footer', { ssr: false }));
const Breadcrumb = dynamic(() => import('../../components/Layouts/Breadcrumb', { ssr: false }));
const WhyDelveinsight = dynamic(() => import('../../components/Consulting/CompetitiveIntelligence/InteractionsSection', { ssr: false }));
const ExitIntent = dynamic(() => import('../../components/Common/ExitIntentForm', { ssr: false }));
import Link from 'next/link';
import DifferentSection from '../../components/SamplePage/DifferentSection';
import InfographicSection from '../../components/SamplePage/InfographicSection';
import SectionHeading from '../../components/Common/SectionHeading';
const SamplePageProfile = ({ data, isMobile }) => {
    const [SamplePage, setSamplePage] = useState([])
    const [scrolled, setScrolled] = useState(0)
    const [scrolledStatus, setScrolledStatus] = useState(false)

    useLayoutEffect(() => {
        if (data) {
            setSamplePage(data)
        }
        console.log(isMobile)
    }, [data])

    useEffect(() => {

        const onScroll = () => setScrolled(window.pageYOffset);
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);


    useEffect(() => {
        if (scrolled > 20) {
            setScrolledStatus(true)
        }
    }, [scrolled])
    const interactionsList = [
        {
            title: "Tailored Business Strategies",
            description: "Optimized business solutions and market research services to cater to your needs and execute market-led business plans.",
            imageSrc: "img/pages/svg/tailored-business-strategies.svg",
            altText: "Tailored Business Strategies",
            link: "/blog/competitive-intelligence-in-healthcare-sector",
        },
        {
            title: "Comprehensive Insights",
            description: "In-depth, syndicated, off the shelf insights into pharma and biotechnology market that help uncover dynamic market trends.",
            imageSrc: "img/pages/svg/comprehensive-insights.svg",
            altText: "Comprehensive Insights",
            link: "/blog/competitive-intelligence-in-healthcare-sector",
        },
        {
            title: "Integrated Data Visualization",
            description: "Dynamic excel-based models offering organized information in the form of visual elements like charts, graphs, and maps for understanding market scenario and outliers.",
            imageSrc: "img/pages/svg/integrated-data-visualization.svg",
            altText: "Integrated Data Visualization",
            link: "/blog/competitive-intelligence-in-healthcare-sector",
        },
        {
            title: "Expert Analysis",
            description: "In-house experienced analyst briefing to facilitate sound business solutions and ROI-oriented strategies.",
            imageSrc: "img/pages/svg/expert-analysis.svg",
            altText: "Expert Analysis",
            link: "/blog/competitive-intelligence-in-healthcare-sector",
        },
        {
            title: "Improved Customer Service",
            description: "Real, well-trained, individual assistance to potential leads, providing them with professional customer service 24/7.",
            imageSrc: "img/pages/svg/improved-customes-service.svg",
            altText: "Improved Customer Service",
            link: "/blog/competitive-intelligence-in-healthcare-sector",
        },
        {
            title: "Competitive Pricing",
            description: "Committed to providing cost-effective, high quality services to clients for to pursue the possible avenues for profitable business.",
            imageSrc: "img/pages/svg/competitive-pricing.svg",
            altText: "Competitive Pricing",
            link: "/blog/competitive-intelligence-in-healthcare-sector",
        },
    ];
    return (
        <>
            <Navbar />
            <div className='mt-65'>
                {/* {scrolledStatus &&
                        <ExitIntent
                            product_name={(SamplePage?.samplePage?.page_title) ? SamplePage?.samplePage?.page_title : SamplePage?.reports?.name}
                            title={SamplePage?.samplePage?.page_title ? SamplePage?.samplePage?.page_title : SamplePage?.reports?.name}
                            shortDescription={'Get a Sneak Peek at the Latest' + ' ' + (SamplePage?.samplePage?.slug ? SamplePage?.samplePage?.slug : SamplePage?.reports?.name)?.replace(/-/g, ' ') + ' ' + 'Report'}
                            page_name="Exit Intent Sample Request"
                            form_name="exit-intent-sample-request"
                        />
                    } */
                }
                <Breadcrumb />
                <div className="flex flex-col justify-center w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-10">
                    <ContentSection
                        data={SamplePage}
                        page_name="Sample Request Page"
                        form_name="sample-request-form"
                        product_name={SamplePage?.samplePage?.page_title}
                        endpoint="/enquiry/sample-page-form"
                        isMobile={isMobile}
                    />
                </div>
                {scrolledStatus &&
                    <>
                        <div className="flex flex-col justify-center w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-10">
                            <DifferentSection data={SamplePage}/>
                        </div>
                        <div className='flex flex-col justify-center w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-10'>
                            <SectionHeading title="Why DelveInsight?" />
                            <WhyDelveinsight data={interactionsList} textColor="text-black" customClass='md:col-span-4 col-span-12 py-4 border-b lg:border-r border-gray-300' />
                        </div>
                        <div className="flex flex-col justify-center w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-10">
                            {(data?.infographics?.image) &&
                                <InfographicSection hrefLink={process.env.APP_URL + "/infographics/" + data?.reports?.slug} pageTitle={(data?.samplePage?.page_title) != null ? <>{data?.samplePage?.page_title}</> : data?.reports?.name} />
                            }
                            </div>
                    </>
                }
            </div>
            {scrolledStatus &&
                <Footer />
            }
        </>
    )
}
export async function getServerSideProps({ req, res, resolvedUrl }) {
    const UA = req.headers['user-agent'];
    const isMobile = Boolean(UA.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    ))
    let redirecting = {
        redirect: {
            permanent: false,
            destination: "/404"
        }
    }

    let slug = resolvedUrl;
    try {
        let cleanedSlug = slug.replace(/\/$/, '');
        cleanedSlug = cleanedSlug.replace(/\/sample-request\//, '');
        let apiUrl = process.env.API_URL + '/sample-page/' + cleanedSlug;
        const output = await fetch(apiUrl, { method: 'GET', headers: { 'Content-Type': 'application/json', } });
        const response = await output.json();
        if (response) {
            return {
                props: {
                    title: (response?.samplePage.meta.meta_title) ? response?.samplePage.meta.meta_title : "Download Sample Page: Get Insights to Stay Ahead in Healthcare Market | DelveInsight",
                    description: (response?.samplePage.meta.meta_description) ? response?.samplePage.meta.meta_description : "Explore our insights by easily downloading sample pages. Dive into a preview of our content to make informed decisions. Download your samples now!",
                    keywords: (response?.samplePage.meta.meta_keywords) ? response?.samplePage.meta.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
                    data: response ? response : [],
                    isMobile: isMobile
                }
            }
        } else {
            return redirecting;
        }
    } catch (error) {
        return redirecting;
    }
}
export default SamplePageProfile;
